import React from "react";
import "../css/grandTotal.css";
import CuInput from "../../all-patient/components/CuInput";
import {
  calculateDiscountedPrice,
  validateDiscAmt,
} from "../../credit_invoice/helpers/_invoiceHelpers";
import CuSpinner from "../../common_component/component/CuSpinner";

const GrandTotal = ({
  total,
  invoicePayload,
  setInvoicePayload,
  onSaveInvoice,
  isLoading,
}) => {
  //("invoicePayload", invoicePayload);
  const handleDiscountType = (e) => {
    const flag = e.target.checked;
    const newDiscountType = flag ? "percentage" : "amount";

    setInvoicePayload((prev) => {
      const discountAmt = prev.discount; // Get the current discount
      const discountedAmt = calculateDiscountedPrice(
        total,
        discountAmt,
        newDiscountType
      );

      return {
        ...prev,
        discount_type: newDiscountType,
        invoice_total: discountedAmt, // Update the invoice total in real-time
      };
    });
  };

  const handleDiscount = (e) => {
    const discountAmt = e.target.value;
    if (Number(discountAmt) < 0) {
      return;
    }
    const isValidate = validateDiscAmt(
      total,
      discountAmt,
      invoicePayload?.discount_type
    );
    if (isValidate) {
      const discountedAmt = calculateDiscountedPrice(
        total,
        discountAmt,
        invoicePayload?.discount_type
      );
      setInvoicePayload((prev) => ({
        ...prev,
        discount: discountAmt,
        invoice_total: discountedAmt,
      }));
    }
  };

  const handleSaveInvoice = (e) => {
    e.preventDefault();
    onSaveInvoice("draft", "grandTotal");
  };

  return (
    <form onSubmit={handleSaveInvoice}>
      <div className="w-full flex flex-col gap-5">
        <div>
          <CuInput label="Amount" value={total} disabled={true} />
        </div>
        <div>
          <div className="flex gap-3">
            <label>
              {invoicePayload?.discount_type === "percentage"
                ? "Percentage Discount "
                : "Lumpsum Discount "}
            </label>
            <input
              type="checkbox"
              onChange={handleDiscountType}
              className="cursor-pointer"
              checked={
                invoicePayload?.discount_type === "amount" ? false : true
              }
              disabled={invoicePayload?.status === "published"}
            />
          </div>
          <CuInput
            type="number"
            value={invoicePayload?.discount}
            onChange={handleDiscount}
            disabled={
              invoicePayload?.status === "published" ||
              invoicePayload?.invoice_total <= 0
            }
          />
        </div>
        <div>
          <CuInput
            label="Total"
            value={invoicePayload?.invoice_total}
            disabled={true}
          />
        </div>
      </div>
      <div className="mt-4">
        <button
          className="cu-btn-gray"
          type="submit"
          disabled={
            invoicePayload?.status === "published" ||
            invoicePayload?.invoice_total <= 0
          }
        >
          {isLoading ? <CuSpinner /> : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default GrandTotal;
